import type {Role} from 'src/openapi/admin/models/Role';

export const ROLE_EXTERNAL_ID_CONTROL = 'role-external-id-control';
export const ROLE_EXTERNAL_ID_REQUIRED_ERROR = 'role-external-id-required-error';
export const ROLE_EXTERNAL_ID_REQUIRED_MESSAGE = 'Role External ID is required field';

export const ROLE_NAME_CONTROL = 'role-name-control';
export const ROLE_NAME_REQUIRED_ERROR = 'role-name-required-error';
export const ROLE_NAME_REQUIRED_MESSAGE = 'Role Name is required field';

export const ROLE_DESCRIPTION_CONTROL = 'role-description-control';
export const ROLE_DESCRIPTION_REQUIRED_ERROR = 'role-description-required-error';
export const ROLE_DESCRIPTION_REQUIRED_MESSAGE = 'Role Description is required field';

export const DEFAULT_ROLE: Role = {
    id: '',
    name: '',
    description: '',
};
